import { render, staticRenderFns } from "./MailingTranslationEditPopup.vue?vue&type=template&id=d21d55e0&"
import script from "./MailingTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./MailingTranslationEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./MailingTranslationEditPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports